const docsAll = {
	en: {
		fullPassport: "Full Passport Scan",
		proofInsurance: "Proof of Health Insurance",
		proofHealth: "Proof of Good Health",
		backgroundCheck: "Background Check",
		financialMeans: "Proof of Financial Means",
		proofAdmission: "Proof of Admission",
		proofLegalStatus: "Proof of Legal Status",
		poa: "Power of Attorney",

//Entry
		declarationOfEntry: "A declaration of entry made within 3 days of entry",
		otherEntryDoc: "Another entry document (e.g., Boarding Pass)",


//Student Stay Extension

		proofPrevProgramCompletion: "Proof of Completion of Previous Program",
		proofProgramContinuation: "Proof of Program Continuation",
		ifNotPresentedBefore: "If Not Presented for Initial Stay Permit",
		childSchoolEnrollment: "Proof of Child(ren)'s School Enrollment",
		childCourseCompletion: "Proof of Child(ren)'s Course Completion",

		certOfAuxCompletion: "Certificate of completion",
		proofOfInvestment: "Proof of sufficient investment",	
		company: "Articles of formation",
		exColonyProve: "Documents proving Iberoamerican or Filipino citizenship",

		businessPlan: "Business plan",
		qualification: "Proof of professional qualification",
		fee790062: "Administrative fee (tasa 790-052)",

		other: "Other",
	},

	en_list: [
		{value: "fullPassport", label: "Full Passport Scan"},
		{value: "proofInsurance", label: "Proof of Health Insurance"},
		{value: "proofHealth", label: "Proof of Good Health"},
		{value: "backgroundCheck", label: "Background Check"},
		{value: "financialMeans", label: "Proof of Financial Means"},
		{value: "proofAdmission", label: "Proof of Admission"},
		{value: "proofLegalStatus", label: "Proof of Legal Status"},
		{value: "poa", label: "Power of Attorney"},
	

//Student Stay Extension
		{value: "proofPrevProgramCompletion", label: "Proof of Completion of Previous Program"},
		{value: "proofProgramContinuation", label: "Proof of Program Continuation"},

//Children
		{value: "childSchoolEnrollment", label: "Proof of Child(ren)'s School Enrollment"},
		{value: "childCourseCompletion", label: "Proof of Chil(ren)'s Course Completion"},

//Entry
		{value: "declarationOfEntry", label: "Declaration of Entry"},
		{value: "otherEntryDoc", label: "Another entry document (e.g., Boarding Pass)"},

		{value: "certOfAuxCompletion", label: "Certificate of completion"},
		{value: "company", label: "Articles of formation of company"},
		{value: "proofOfInvestment", label: "Proof of sufficient investment"},
		{value: "exColonyProve", label: "Documents proving Iberoamerican or Filipino citizenship"},
		{value: "fee790062", label: "Administrative fee (tasa 790-052)"},
		{value: "businessPlan", label: "Business plan"},
		{value: "qualification", label: "Proof of professional qualification"},

// 		businessPlan: "Business plan",
// 		qualification: "Proof of professional qualification",
//Other
		{value: "other", label: "Other"},

	]
}

const procedureDocs = {
	studentStay: {
		required: ["fullPassport", "proofLegalStatus", "proofAdmission", "financialMeans", "proofInsurance", "backgroundCheck", "proofGoodHealth"],
		optional: [],
		maybe: ["poa"],
	}
}

export default docsAll;
